import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { QuotationHistoryResponse } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { QuotationSummaryService } from 'src/app/_Services/quotationNew/quotationsummary.service';

@Component({
  selector: 'app-quotation-history-popup',
  templateUrl: './quotation-history-popup.component.html',
  styleUrls: ['./quotation-history-popup.component.scss']
})
export class QuotationHistoryPopupComponent implements OnInit {

  @Input() quotationId: number;
  public hitoryData: QuotationHistoryResponse[] = [];
  uploadHistroyloading = false;
  bookingNo: Array<string> = [];

  componentDestroyed$ = new Subject<boolean>();

  /** -----------------------
   *   FINAL FIXED UI MAPPER
   * ----------------------*/
  historyUIMap: any = {
    approved: {
      match: (item: any) => item.statusId === 3,
      icon: 'assets/images/new-set/filled-green-pass.svg',
      title: 'Approved',
      isBadge: false,
      titleClass: 'green_text'
    },
    rejected: {
      match: (item: any) => item.statusId === 2,
      icon: 'assets/images/new-set/fail-circle.svg',
      title: 'Rejected',
      isBadge: false,
      titleClass: 'red_text'
    },
    uploaded: {
      match: (item: any) => item.isQuotationReuploaded == true,   
      icon: 'assets/images/filled-quotation.svg',
      title: 'Quotation Re-uploaded',
      isBadge: true,
      titleClass: ''
    },
    reuploaded: {
      match: (item: any) => item.isQuotationReuploaded == false,  
      icon: 'assets/images/filled-quotation.svg',
      title: 'Quotation Uploaded',
      isBadge: true,
      titleClass: ''
    }
  };

  constructor(
    public quatationNewService: QuotationSummaryService,
    public activeModal: NgbActiveModal
  ) { 
      this.bookingNo = [];
  }


  ngOnInit(): void {
    this.uploadHistroyloading = true;
    this.bookingNo = [];
    this.quatationNewService.getQuotationHistory(this.quotationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (response) => {
          this.hitoryData = response;
          this.bookingNo = [];
          this.hitoryData.forEach((history) => {
       if (history.bookingNo && Array.isArray(history.bookingNo)) {
        history.bookingNo.forEach((bn) => {
          if (bn != null && !this.bookingNo.includes(bn)) {
            this.bookingNo.push(bn);
          }
        });
          }
        });
          this.uploadHistroyloading = false;
        },
        () => this.uploadHistroyloading = false
      );
  }

  getHistoryUI(item: any) {
    return Object.values(this.historyUIMap).find((x: any) => x.match(item));
  }

  closePopup() {
    this.activeModal.dismiss();
  }
}
